import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './styles.css';
import Avatar from '../../../../components/Avatar';
import LinkCandidateProfile from '../../../../components/LinkCandidateProfile';
import RemoveButton from '../../../../components/RemoveButton';
import ENDPOINT from '../../../../constants/endpoints';
import useApi from '../../../../hooks/useApi';
import ConfirmDialog from '../../../Dialog/components/ConfirmDialog';
import ResponseErrorDialog from '../../../Dialog/components/ResponseErrorDialog';

const FeedPostComment = props => {
  const {
    user,
    comment: {
      CommentID,
      CandidateID,
      NewsID,
      FullName,
      PictureUrl,
      NewsFeedDateAdd,
      Text,
      ShowReply,
      Removable,
      ViewProfile,
    },
    onClickReplyHandler,
    onClickRemoveHandler,
  } = props;

  const api = useApi();

  const [isBtnDisabled, setBtnDisabled] = useState(false);

  const handleClickReply = () => {
    onClickReplyHandler(FullName);
  };

  const handleClickRemove = () => {
    setBtnDisabled(true);
    ConfirmDialog({
      bodyRender: 'Are you sure you want to delete this comment?',
      dismissWhenClose: false,
    }).then(
      () => {
        api.post(
          ENDPOINT.ACTION.FEED.DELETE_COMMENT,
          { id: CommentID, newsId: NewsID },
          {
            handleError: response => {
              setBtnDisabled(false);
              ResponseErrorDialog({ response });
            },
            handleSuccess: () => {
              setBtnDisabled(false);
              onClickRemoveHandler({ NewsID, CommentID });
            },
          }
        );
      },
      () => setBtnDisabled(false)
    );
  };

  return (
    <div className="feed-post-comment">
      {Removable && (
        <RemoveButton
          disabled={isBtnDisabled}
          controlFunc={handleClickRemove}
          btnBg="transparent"
          btnHoverBg="#f40"
          customStyles={{
            top: '1px',
            right: '1px',
            borderColor: 'transparent',
          }}
        />
      )}
      <div className="feed-post-comment__container">
        <div className="feed-post-comment__visual">
          <Avatar size={38} image={PictureUrl} />
        </div>

        <div className="feed-post-comment__content">
          <LinkCandidateProfile
            user={user}
            id={CandidateID}
            name={FullName}
            cls="feed-post-comment__author"
            viewProfile={ViewProfile === 'Yes'}
          />{' '}
          {Text}
          <div className="feed-post-comment__footer">
            <span className="feed-post-comment__date">{NewsFeedDateAdd}</span>
            {ShowReply && (
              <span
                className="feed-post-comment__reply-link"
                onClick={handleClickReply}
              >
                Reply
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

FeedPostComment.propTypes = {
  user: PropTypes.object.isRequired,
  comment: PropTypes.shape({
    NewsID: PropTypes.string.isRequired,
    CommentID: PropTypes.string.isRequired,
    FullName: PropTypes.string.isRequired,
    PictureUrl: PropTypes.string.isRequired,
    DateAdd: PropTypes.string.isRequired,
    NewsFeedDateAdd: PropTypes.string.isRequired,
    Text: PropTypes.string.isRequired,
    Removable: PropTypes.bool.isRequired,
    ShowReply: PropTypes.bool.isRequired,
  }),
  onClickReplyHandler: PropTypes.func.isRequired,
};

export default FeedPostComment;
